import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API } from '../../api';

@Injectable({
    providedIn: 'root'
})
export class FormulaService {
    private url: string = API + '/formula';

    constructor(private http: HttpClient) { }

    getFormulas(): Observable<any> {
        return this.http.get(this.url);
    }

    getFormula(id: number): Observable<any> {
        return this.http.get(`${this.url}/${id}`);
    }

    createFormula(product: any): Observable<any> {
        return this.http.post(this.url, product);
    }

    updateFormula(id: number, product: any): Observable<any> {
        return this.http.put(`${this.url}/${id}`, product);
    }

    deleteFormula(id: number): Observable<any> {
        return this.http.delete(`${this.url}/${id}`);
    }
}
